import React, { FC, useEffect } from 'react';
import { WithTranslation, withTranslation } from '@wix/wix-i18n-config';
import cs from 'classnames';
import s from './mobileApp.scss';
import * as BIManager from '../../utils/bi';
import { MobileToolbar } from '../partials/MobileToolbar/MobileToolbar';
import { fedopsLogger } from '../../utils/fedops-logger';
import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { InfoButton } from '../InfoButton/InfoButton';
import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { mobileAppDataHooks } from './MobileApp.dataHooks';
import { MobileWixStudioToolbar } from '../partials/MobileWixStudioToolbar/MobileWixStudioToolbar';
import { buildIframeUrl } from '../../utils/urlBuilders';

const MobileAppCmp: FC<{ dataHook?: string } & WithTranslation> = ({ t, dataHook }) => {
  const { isInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { url, title, isStudio } = template;
  const previewUrl = buildIframeUrl(url, { showMobileView: true });

  useEffect(() => {
    BIManager.reportLoadSuccess();
    fedopsLogger.appLoaded();
  }, []);

  let toolbar: React.ReactNode;

  if (isStudio) {
    toolbar = <MobileWixStudioToolbar template={template} dataHook={mobileAppDataHooks.wixStudioToolbar} />;
  } else {
    toolbar = (
      <MobileToolbar dataHook={mobileAppDataHooks.mobileToolBar}>
        <InfoButton dataHook={mobileAppDataHooks.infoView} />
      </MobileToolbar>
    );
  }

  return (
    <div data-hook={dataHook}>
      {toolbar}
      <iframe
        data-hook={mobileAppDataHooks.mobileIframe}
        title={title}
        src={previewUrl}
        width="100%"
        height="100%"
        className={cs(s.iframe, { [s.iframeHidden]: isInfoShown })}
      />
      {!isStudio && <InfoPopUp isMobile dataHook={mobileAppDataHooks.infoPopUp} />}
    </div>
  );
};

export const MobileApp = withTranslation()(MobileAppCmp);
